var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"app"}},[(_vm.isChrome)?_c('div',[_vm._v(" "+_vm._s(_vm.stateSync)+" "),(_vm.isChrome)?_c('router-view'):_vm._e()],1):_c('Unsupportedbrowser')],1),_c('Internet'),_c('LoginModals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }